export function resolveRowSpan(gridSettings) {
    const rowStart = Number.isFinite(gridSettings?.rowStart) ? gridSettings.rowStart : null;
    const rowEnd = Number.isFinite(gridSettings?.rowEnd) ? gridSettings.rowEnd : null;

    if (rowStart == null && rowEnd == null) {
        return { rowStart: null, rowEnd: null };
    }
    if (rowStart != null && rowEnd != null) {
        return { rowStart, rowEnd };
    }
    if (rowStart != null) {
        return { rowStart, rowEnd: rowStart + 1 };
    }
    return { rowStart: Math.max(1, rowEnd - 1), rowEnd };
}
